<script setup>
const props = defineProps({
  item: Object,
  slug: String,
  activeIndex: Number,
  index: Number,
  type: String,
})
const textFontSize = computed(() => {
  switch (props.item.size) {
    case 'sm':
      return 'text-sm lg:text-md'
    case 'md':
      return 'text-md lg:text-lg'
    case 'lg':
      return 'text-lg lg:text-xl'
    case 'xl':
      return 'text-xl lg:text-2xl'
    default:
      return 'text-lg lg:text-xl'
  }
})
const router = useRouter()
function filteredRoute() {
  const category = props.slug
  const regex = new RegExp('\\\/th\\\/+', '')
  const result = category.replace(regex, '')
  return `${result}`
}

</script>

<template>
  <div
    class="transition-[shadow,transform] relative h-full flex flex-col overflow-hidden rounded-md px-4 pb-6 pt-4 duration-200"
    :class="[activeIndex === index ? 'shadow-custom-lg shadow-shadow-light/10 scale-105' : 'scale-100']"
  >
    <div :class="activeIndex === index ? 'text-secondary-red-100' : 'text-secondary-gray-400'" class="text-sm font-semibold transition-colors duration-200">
      {{ item.header }}
    </div>
    <h3 class="line-clamp-2 mb-custom-md max-h-[65px] min-h-[65px] font-bold text-primary" :class="textFontSize">
      {{ item.title }}
    </h3>
    <div class="mt-auto min-h-[45px] flex items-end gap-3 2xl:min-h-auto">
      <NuxtLink :to="localePath({ path: filteredRoute() })">
        <UIButton class="flex items-center whitespace-nowrap rounded-md" :theme="activeIndex === index ? 'fill' : 'text'" size="xs">
          {{ $t('button.more') }}
        </UIButton>
      </NuxtLink>
      <NuxtLink
        v-if="item.register"
        :to="localePath({
          path: `/dexon-training-center/training-registration`,
          query: {
            course: type,
            method: item.title.toLowerCase(),
          },
        })
        "
      >
        <UIButton class="flex items-center rounded-md" :class="activeIndex === index ? '' : '!hidden'" :theme="activeIndex === index ? 'outline' : 'text'" size="xs">
          {{ $t('button.register') }}
        </UIButton>
      </NuxtLink>
    </div>
    <div :class="activeIndex === index ? 'opacity-100' : 'opacity-0'" class="transition-all duration-200">
      <DecorlationRstriped current-color="text-secondary-gray-300" class="absolute bottom-[-15px] right-[-30px] z-[-1] h-[150px] w-[200px] origin-bottom-right" />
    </div>
  </div>
</template>
